<template>
    <b-container class="mt-3">
        <b-row align-h="center">
            <b-col md="8" lg="6">
                <b-card :header="$t('Login')">
                    <b-form @submit.prevent="login">
                        <b-form-group
                            label-for="email"
                            :label="$t('E-Mail Address')"
                            :state="form.errors.has('email') ? false : null"
                            :invalid-feedback="form.errors.get('email')"
                        >
                            <b-form-input
                                id="email"
                                v-model="form.email"
                                required
                                autofocus
                                :state="form.errors.has('email') ? false : null"
                            />
                        </b-form-group>

                        <b-form-group
                            label-for="password"
                            :label="$t('Password')"
                            :state="form.errors.has('password') ? false : null"
                            :invalid-feedback="form.errors.get('password')"
                        >
                            <b-form-input
                                id="password"
                                v-model="form.password"
                                type="password"
                                required
                                :state="form.errors.has('password') ? false : null"
                            />
                        </b-form-group>

                        <b-form-checkbox
                            id="checkbox-1"
                            v-model="rememberMe"
                            class="mb-5"
                        >
                            {{ $t('Remember Me') }}
                        </b-form-checkbox>

                        <b-btn type="submit" variant="primary">
                            {{ $t('Login') }}
                        </b-btn>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>

    import Form from 'vform';

    export default {
        name: 'Login',
        data() {
            return {
                form: new Form(),
                rememberMe: true,
            };
        },

        methods: {
            login() {
                let redirect = this.$auth.redirect();

                this.$auth.login({
                    data: this.form,
                    staySignedIn: this.rememberMe,
                    redirect: redirect ? redirect.from : {name: 'projects.index'},
                    fetchUser: true,
                    error: () => {}
                })
                    .catch(e => {
                        if (!e.response) throw e;

                        let response = e.response;
                        if (response.status === 422) {
                            this.form.errors.set(response.data.errors);
                        }
                    });
            },
        },
    };
</script>
